// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes rellpay-skeleton-loading {
  0% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0 50%;
  }
}
.rellpay-skeleton {
  height: 32px;
  background: linear-gradient(90deg, rgba(0, 0, 0, 0.06) 25%, rgba(0, 0, 0, 0.15) 36%, rgba(0, 0, 0, 0.06) 64%);
  background-size: 400% 100%;
  animation: rellpay-skeleton-loading 1.4s ease infinite;
}
.rellpay-skeleton-small {
  height: 24px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Skeleton/style.css"],"names":[],"mappings":"AAAA;EACI;IACI,6BAAA;EACN;EACE;IACI,0BAAA;EACN;AACF;AAEA;EACI,YAAA;EACA,6GAAA;EACA,0BAAA;EACA,sDAAA;AAAJ;AAGA;EACI,YAAA;AADJ","sourcesContent":["@keyframes rellpay-skeleton-loading {\n    0% {\n        background-position: 100% 50%;\n    }\n    100% {\n        background-position: 0 50%;\n    }\n}\n\n.rellpay-skeleton {\n    height: 32px;\n    background: linear-gradient(90deg, rgba(0, 0, 0, 0.06) 25%, rgba(0, 0, 0, 0.15) 36%, rgba(0, 0, 0, 0.06) 64%);\n    background-size: 400% 100%;\n    animation: rellpay-skeleton-loading 1.4s ease infinite;\n}\n\n.rellpay-skeleton-small {\n    height: 24px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
